module.exports = __webpack_public_path__ + "assets/images/b_r.73ec6803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/b_r.png
// module id = 373
// module chunks = 1